export default __webpack_public_path__ + "static/national-yards-mobile-bda5647072ed3e54763d1066bd303c93.svg";